import { render, staticRenderFns } from "./TypeOfRoadList.vue?vue&type=template&id=2a080152"
import script from "./TypeOfRoadList.vue?vue&type=script&lang=js"
export * from "./TypeOfRoadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports